<script>
import formatCurrency from "@utils/format-currency";
import formatPrice from "@utils/format-price";
import { authComputed, merchantComputed } from '@store/helpers'
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";
export default {
  components: {
    CarouselImage: () => import("./CarouselImage.Jtails"),
  },
  props: {
    reservationItem: {
      type: Object,
      default: () => {
        return {
          "description": "迷你犬基礎洗護（含：剪指甲、清耳朵、小修臉部雜毛、小修足緣、剃腳底毛、剃肚子毛、剃肛門毛擠肛門腺+牛奶SPA浴程）",
          "images": [
            {
              "path": "https://assets.codepen.io/1759070/service-1%402x.png",
              "default": 1
            },
            {
              "path": "https://assets.codepen.io/1759070/service-2%402x.png",
              "default": 0
            },
            {
              "path": "https://assets.codepen.io/1759070/service-3%402x.png",
              "default": 0
            }
          ],
        }
      }
    },
  },
  computed :{
    ...authComputed,
  },
  methods: {
    formatCurrency,
    formatPrice,
    memberLevelPriceDiscount
  }
}
</script>
<!-- section template -->
<template>
  <section id="description" :class="[$style.itemSectionDescriptionJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]" class="section pt-5">
    <BaseSectionTitleJtails
      v-if="!$globalIsDingBeauty"
      class="itemSectionDescriptionJtails__title"
      title="服務簡述"
      title-class="text-primary-dark"
      sub-title="Service"
      :description="reservationItem.description"
    />
    <BaseSectionTitleSecondary
      v-else
      title="服務簡述"
      :description="reservationItem.description"
    />
    
    <CarouselImage
      v-if="!!reservationItem.images[0] && !$globalIsDingBeauty"
      :carousel-list="reservationItem.images"
      class="itemSectionDescriptionJtails__image"
    />
    <template v-if="$globalIsDingBeauty">
      <BaseSectionTitleSecondary
        title="課程價格"
      />
      <div class="d-flex justify-content-between itemSectionDescriptionJtails__priceBox">
        <span>單次預約</span>
        <span>
          <span
            v-if="reservationItem.levelDiscount > 0"
            class="itemSectionInfoJtails__basePrice"
          >售價NT$ {{ formatCurrency(reservationItem.price) }}</span>
          <span
            v-if="reservationItem.price < reservationItem.basePrice  && !reservationItem.levelDiscount > 0"
            class="itemSectionInfoJtails__basePrice"
          >原價NT$ {{ formatCurrency(reservationItem.basePrice) }}</span>
          <span class="itemSectionInfoJtails__price">
            
            {{ reservationItem.levelDiscount > 0 ? `會員價 ${formatPrice(memberLevelPriceDiscount(reservationItem.price, reservationItem))}` : formatPrice(reservationItem.price)}}
            <span v-if="!!reservationItem.priceIsFlexible" class="fs-sm">起</span>
          </span>
        </span>
      </div>
    </template>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.itemSectionDescriptionJtails {
  @include max-md {
    display: flex;
    flex-direction: column;
    padding-top: 0;
    padding-bottom: 0;
  }

  :global {
    .itemSectionDescriptionJtails {
      &__image {
        @include max-md {
          order: 1;
        }
      }

      &__title {
        @include max-md {
          order: 2;
          margin-top: 1.8rem;
        }
      }
    }

  }
  &.isStyleDingBeauty {
    border-top: 1px solid $color-line-2;
    margin-top: 3rem !important;
    :global {
      .itemSectionDescriptionJtails{
        &__priceBox {
          background: $color-bg-default;
          padding: 0.875rem;
        }
        &__price {
          font-family: $font-number;
        }
        &__basePrice {
          margin-right: 0.5rem;
          font-family: $font-number;
          font-size: 0.875rem;
          color: $color-gray-2;
          text-decoration: line-through;
        }
      }
    }
  }
}
</style>
